import { useRef, useEffect } from "react"

type FunctionArg = () => void

// A useEffect that doesn't fire at the first render
const useSubsequentEffect = (fn: FunctionArg, deps: any[]) => {
  const isMountedRef = useRef(false)
  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true
      return
    }
    return fn()
    // eslint-disable-next-line
  }, deps)
}

export default useSubsequentEffect
